import React, { useEffect, useState } from 'react'
import { FaGithub, FaJava, FaPython } from 'react-icons/fa';
import { IoMdClose, IoMdMailUnread } from 'react-icons/io';
import { IoLogoJavascript } from 'react-icons/io5';
import { RxExternalLink } from 'react-icons/rx';
import { Spotlight } from './components/ui/spotlight.tsx';
// import { FlipWords } from './components/ui/flip-words.tsx';
import { HoverBorderGradient } from './components/ui/hover-border-gradient.tsx';
import { HoverEffect } from './components/ui/card-hover-effect.tsx';
import { SiTypescript } from 'react-icons/si';
import { FloatingNav } from './components/ui/floating-navbar.tsx';
import { ImagesSlider } from './components/ui/image-slider.tsx';
import { BackgroundBeams } from './components/ui/background-beams.tsx';

const Home = () => {

    const [show, setShow] = useState(false)
    // const words = ["modern", "aesthetic", "better", "cute", "beautiful", "minimalistic"];


    const toggleProfile = () => {
        setShow(!show)
        console.log(show);
    }

    useEffect(() => {
      document.body.style.overflowY = show? "hidden" : "auto";
    }, [show])
    

    const projects = [
        {
            title: "Dine-In",
            description:
                "This restaurant app facilitates seamless food ordering with a user-friendly interface for customers to browse menus, place orders, and track order status. It includes robust kitchen management tools for order processing and tracking, along with kitchen management for better customer experience.",
            link: "https://github.com/KoushikMCN/Dine-In/",
            techstack: "NextJS, TailwindCSS, Firebase"
        },
        {
            title: "ChETH Funds",
            description:
                "Ethereum-driven chit funds offer decentralized operations for participant enrollment, bid management, and payout distribution. This solution leverages blockchain technology to ensure transparency and security in managing chit fund activities.",
            link: "https://github.com/synapsecode/chETHFunds/",
            techstack: "NextJS, Solidity, Firebase, TailwindCSS"
        },
        {
            title: "Credentus",
            description:
                "A decentralized credentialing system allows companies to issue secure credentials to individuals using blockchain technology, ensuring transparency and reducing fraud risks. This system enhances verification processes and enables seamless sharing of verified credentials across platforms.",
            link: "https://github.com/dawksh/aventus-creds/tree/koushik/",
            techstack: "NextJS, Solidity, Supabase, TailwindCSS"
        },
        {
            title: "VisionVent",
            description:
                "A platform where individuals can invest directly in cutting-edge research centers, fueling groundbreaking discoveries. From Bio-Tech to AI, this platform bridges investors with scientists at the forefront of innovation. Empowering investors to support scientific progress and potentially benefit from its impact.",
            link: "https://github.com/SomnathUmapathi/visionvent/",
            techstack: "NextJS, MongoDB, TailwindCSS, Flutter"
        },
        {
            title: "Deus-Careers",
            description:
                "The career-finding platform developed and designed by me includes a robust admin dashboard for effortless applicant management and a decent UI with really good user experience for the job applicants. It simplifies the process of reviewing and approving job applications, enhancing efficiency.",
            link: "https://deus-careers.vercel.app/",
            techstack: "NextJS, Solidity, Supabase, TailwindCSS"
        },
        {
            title: "Recurzive",
            description:
                "A website developed and designed using ReactJS, TailwindCSS for a national level hackathon, conducted by DSCE. This has made use of acertainity UI in order to enhance the aesthetic appeal of the website. We have also used firebase to store the queries posted by users/participants.",
            link: "https://recurzive.xyz/",
            techstack: "ReactJS, Firebase, TailwindCSS"
        },
    ];

    const navItems = [
        {
            name: "About Me",
            link: "#about",
        },
        {
            name: "Works",
            link: "#works",
        },
        {
            name: "Skills",
            link: "#skills",
        },
        {
            name: "MEE",
            link: "#MEE",
        },
    ]

    return (
        <div>
            <div className="App p-8 sm:p-8 sm:pl-16 text-white max-w-screen min-h-screen bg-black h-auto font-page">
                {
                    !show &&
                    <Spotlight className='text-xl -mt-4 sm:mt-0' fill={'blue'} />
                }
                <header className='mt-14 sm:mt-8 sm:pr-14 md:-mt-4'>
                    <nav className=' w-2/3 m-auto'>
                        <ul className='hidden xl:flex justify-around text-xl px-24 my-10'>
                            <li className='hover:scale-110 transition duration-300 '><a href='#about'>About Me</a></li>
                            <li className='hover:scale-110 transition duration-300 '><a href='#works'>Works</a></li>
                            <li className='hover:scale-110 transition duration-300 '><a href='#skills'>Skills</a></li>
                        </ul>
                        <FloatingNav className='hidden lg:flex' navItems={navItems} />
                    </nav>
                    <img src='profile.JPG' alt='Profile' onClick={() => toggleProfile()} className='cursor-pointer size-24 sm:size-36 rounded-full' />
                    <div className='flex lg:justify-between flex-col lg:flex-row'>
                        <div>
                            {/* <p className=''>Hi, I am</p> */}
                            <h1 className='text-5xl text-yellow-400 font-bold'>Koushik M Bhagavath</h1>
                            <h2 className='text-xl text-slate-300'>Full Stack Web Developer</h2>
                        </div>
                        <div className='flex relative gap-x-2'>
                            <HoverBorderGradient as={'a'} containerClassName={`border-0 ${show && 'hidden'}`}>
                                <a href='https://github.com/KoushikMCN' target='_blank' rel="noreferrer" className='text-nowrap flex justify-center items-center'>My GitHub&nbsp;<FaGithub className='text-cyan-400' /></a>
                            </HoverBorderGradient>
                            <HoverBorderGradient as={'a'} clockwise={false} containerClassName={`border-0 ${show && 'hidden'}`}>
                                <a href='https://mail.google.com/mail/?view=cm&fs=1&to=koushik.mbp@gmail.com'  target='_blank' className='text-nowrap flex justify-center items-center'>Work with me&nbsp;<IoMdMailUnread className='text-cyan-400' /></a>
                            </HoverBorderGradient>
                        </div>
                    </div>
                    <a href='/resume' className='text-cyan-400'>Resume<RxExternalLink className='inline-block relative -top-0.5' /></a>
                </header>
                <main className='sm:pr-14'>
                    {/* <div className='text-3xl mt-20'>
                        I build<FlipWords words={words} duration={800} className='font-bold' />websites.
                    </div> */}
                    <section className='text-lg pt-36 pb-32' id='about'>
                        <h2 className='text-4xl text-nowrap mb-2 text-cyan-400 font-bold'>About Me</h2>
                        <p className='text-justify'>
                            I am a web developer with experience in building web applications using popular JS frameworks/libraries. I have good experience building the frontend with <strong>NextJS</strong>, <strong>ReactJS</strong> and the backend with <strong>NodeJS/ExpressJS</strong> and <strong>Flask</strong>.
                            I have also developed and designed a few websites using basic HTML and vanilla CSS and JavaScript. However, now I am working more with NextJS since it is the best framework in my opinion. I am also proficient in <strong>TailwindCSS</strong> and have also been using it for majority of my projects. For database, I have previously used <strong>Firebase</strong> <strong>Supabase</strong> and <strong>PostgreSQL</strong> and I have experience using <strong>MongoDB</strong> too. The <strong>MERN</strong> stack and <strong>NextJS+TailwindCSS+Supabase</strong> have now become my favorite to work with. I am currently learning <strong>ReactNative</strong> and <strong>GoLang</strong> for application development. I'm also looking forward to diving into <strong>Web3</strong> to build decentralized apps(dApps) with <strong>Solidity</strong>. It's all about using blockchain for cool, secure apps that anyone can use. Excited to dive into DeFi, NFTs, and see where this tech takes me!
                        </p>
                    </section>
                    <BackgroundBeams className='h-[300vh] mt-[300vh] md:mt-[120vh]' />
                    <section className='text-lg py-28' id='works'>
                        <h2 className='text-4xl text-nowrap mb-2 text-cyan-400 font-bold'>Works/Projects</h2>
                        <HoverEffect items={projects} />
                    </section>
                    {/* <BackgroundBeams className='lg:hidden h-[300vh] mt-[120vh]' /> */}
                    <section className='text-lg py-28' id='skills'>
                        <h2 className="text-4xl mb-2 text-cyan-400 font-bold">Skills & Tools</h2>
                        <div className='flex flex-col gap-y-4'>
                            <div>
                                <h3 className='text-xl text-yellow-400 font-bold'>Languages</h3>
                                <div className='flex gap-5 flex-wrap'>
                                    <IoLogoJavascript className='size-16 text-yellow-400 bg-slate-500/20 rounded-lg p-2' />
                                    <FaJava className='size-16 text-blue-400 bg-slate-500/20 rounded-lg p-2' />
                                    <SiTypescript className='size-16 text-blue-500 bg-slate-500/20 rounded-lg p-2' />
                                    <img src='https://imgs.search.brave.com/M-FiGkB1jPVADW6xtp-i7TJcdhipqz463z8s2cuR3WY/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9hc3Nl/dHMuc3RpY2twbmcu/Y29tL2ltYWdlcy81/ODQ4MTUyZmNlZjEw/MTRjMGI1ZTQ5Njcu/cG5n' alt='Python' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='https://imgs.search.brave.com/-aqoL7TbF81YYKKNWeBQt95KSjJ7exTkEElmLx4-xmk/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9yYXcu/Z2l0aHVidXNlcmNv/bnRlbnQuY29tL2lz/b2NwcC9sb2dvcy9t/YXN0ZXIvY3BwX2xv/Z28ucG5n' alt='C++' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='https://imgs.search.brave.com/rHu5ELNCeqIeCukLVQkhVTnsE5PsZGH09qHe6XWJ-xA/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9zZWVr/bG9nby5jb20vaW1h/Z2VzL0MvYy1sYW5n/dWFnZS1sb2dvLUNF/MEY5MkU2ODMtc2Vl/a2xvZ28uY29tLnBu/Zw' alt='C' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                </div>
                            </div>
                            <div>
                                <h3 className='text-xl text-yellow-400 font-bold'>Frameworks/Libraries</h3>
                                <div className='flex gap-5 flex-wrap'>
                                    <img src='react.webp' alt='ReactJS' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='next.png' alt='NextJS' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='jquery.png' alt='jQuery' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='flask.png' alt='flask' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                </div>
                            </div>
                            <div>
                                <h3 className='text-xl text-yellow-400 font-bold'>Technologies</h3>
                                <div className='flex gap-5 flex-wrap'>
                                    <img src='tailwind.png' alt='TailwindCSS' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='firebase.webp' alt='Firebase' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='https://imgs.search.brave.com/bLKSpWf77eOn8Wy1IrD7usyP15scGGkETBunVAgX4Kc/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9yYXcu/Z2l0aHVidXNlcmNv/bnRlbnQuY29tL2dp/dGh1Yi9leHBsb3Jl/L2Y0ZWM1MzQ3YTM2/ZTA2NTQwYTY5Mzc2/NzUzYTdjMzdhOGNi/NWExMzYvdG9waWNz/L3N1cGFiYXNlL3N1/cGFiYXNlLnBuZw' alt='Supabase' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                </div>
                            </div>
                            <div>
                                <h3 className='text-xl text-yellow-400 font-bold'>Databases+Backend</h3>
                                <div className='flex gap-5 flex-wrap'>
                                    <img src='firebase.webp' alt='Firebase' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='https://imgs.search.brave.com/bLKSpWf77eOn8Wy1IrD7usyP15scGGkETBunVAgX4Kc/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9yYXcu/Z2l0aHVidXNlcmNv/bnRlbnQuY29tL2dp/dGh1Yi9leHBsb3Jl/L2Y0ZWM1MzQ3YTM2/ZTA2NTQwYTY5Mzc2/NzUzYTdjMzdhOGNi/NWExMzYvdG9waWNz/L3N1cGFiYXNlL3N1/cGFiYXNlLnBuZw' alt='Supabase' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='postgresql.webp' alt='PostgreSQL' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='mongodb.png' alt='MongoDB' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='https://imgs.search.brave.com/4Afaev-gC-2jBzkXD9NzF3q0ZXlqYmFVquG2mqUFSBs/rs:fit:860:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy82/LzY0L0V4cHJlc3Nq/cy5wbmc' alt='ExpressJS' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='https://imgs.search.brave.com/TTqzgX8Jg-WUy2fCjwmMySwIiwFsC_vv7N2G5ZnzUYI/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9jZG4u/aWNvbnNjb3V0LmNv/bS9pY29uL2ZyZWUv/cG5nLTI1Ni9mcmVl/LW5vZGVqcy0yLTIy/NjAzNS5wbmc_Zj13/ZWJwJnc9MTI4' alt='ExpressJS' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='next.png' alt='NextJS' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                    <img src='https://binary.transparency.dev/images/logo_golang_hor.svg' alt='GoLang' className='bg-slate-500/20 p-2 rounded-lg size-16' />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className='text-lg pt-28' id='MEE'>
                        <h2 className='text-4xl mb-2 text-cyan-400 font-bold'>ME</h2>
                        <div className='flex flex-col md:flex-row justify-between items-center'>
                            <div className='md:w-3/5'>
                                <p className='text-2xl text-yellow-400'>More about me :p</p>
                                <ul className='list-disc p-4'>
                                    <li>A passionate rider</li>
                                    <li>Average music enthusiast</li>
                                    <li>Like going on hikes</li>
                                    <li>Seafood and ice cream aficionado</li>
                                    <li>A beach person</li>
                                    <li>Fan of LH44</li>
                                </ul>
                                <div className='hidden my-10 md:flex justify-center items-center'>
                                    <iframe title='Spotify' src="https://open.spotify.com/embed/playlist/37i9dQZF1EpunZEncdDzba?utm_source=generator&theme=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" className='w-full'></iframe>
                                </div>
                            </div>
                            <ImagesSlider images={['./images/MEE (1).jpg', './images/MEE (2).jpg', './images/MEE (3).jpg', './images/MEE (4).jpg', './images/MEE (5).jpg', './images/MEE (6).jpg']}
                                direction='down'
                                className='size-[300px] md:size-[400px] rounded-lg text-slate-300/15' >
                                Image Slider
                            </ImagesSlider>
                        </div>
                        <div className='flex my-10 md:hidden justify-center items-center'>
                            <iframe title='Spotify' src="https://open.spotify.com/embed/playlist/37i9dQZF1EpunZEncdDzba?utm_source=generator&theme=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" className='w-full'></iframe>
                        </div>
                    </section>
                </main>
            </div>
            {
                show &&
                <div className='fixed top-0 flex h-full w-full justify-center backdrop-blur items-center bg-slate-800/90' onClick={() => toggleProfile()}>
                    <button className='absolute top-5 right-5 text-orange-600 text-2xl sm:text-5xl' onClick={() => toggleProfile()}><IoMdClose /></button>
                    <img src='profile.JPG' alt='Profile' className='size-52 rounded-full' onClick={(e) => e.stopPropagation()} />
                </div>
            }
        </div>
    )
}

export default Home
